import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 9.768,
	height: 12.698,
	viewBox: "0 0 9.768 12.698",
	fill: "",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "lock_FILL1_wght200_GRAD200_opsz40",
		d: "M12.384,3.708a2.762,2.762,0,0,1,2.027.838,2.781,2.781,0,0,1,.838,2.043V7.974h.781a1.224,1.224,0,0,1,1.237,1.237v5.975a1.176,1.176,0,0,1-.358.863,1.2,1.2,0,0,1-.879.358H8.737a1.2,1.2,0,0,1-.879-.358,1.176,1.176,0,0,1-.358-.863V9.211A1.224,1.224,0,0,1,8.737,7.974h.781V6.59a2.781,2.781,0,0,1,.838-2.043A2.762,2.762,0,0,1,12.384,3.708Zm0,.847a1.935,1.935,0,0,0-1.433.594,1.976,1.976,0,0,0-.586,1.441V7.974H14.4V6.59a1.976,1.976,0,0,0-.586-1.441A1.935,1.935,0,0,0,12.384,4.555Zm0,6.545a1.046,1.046,0,0,0-.79.334,1.108,1.108,0,0,0-.317.79,1.111,1.111,0,0,0,1.9.781,1.08,1.08,0,0,0,.317-.781,1.093,1.093,0,0,0-.325-.79A1.053,1.053,0,0,0,12.384,11.1Z",
		transform: "translate(-7.5 -3.708)",
		fill: "#fff"
	})
});
export { SvgIconLocked as ReactComponent };
